import React from 'react';

import { useFulfillmentPlanIdContext } from '../../../../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import { useGetAddressValidationStatus } from '../use-shipment-details-address';
import AddressValidationStatus from '../../../../../../../components/address-validation/validation-status';

import style from '../address.module.less';

const AddressValidationStatusContainer = () => {
  const fulfillmentPlanId = useFulfillmentPlanIdContext();
  const { isEmptyAddress, countryCode, residentialIndicator, validation, validationMessage } =
    useGetAddressValidationStatus(fulfillmentPlanId);
  return (
    <AddressValidationStatus
      className={style['address-validation-status']}
      countryCode={countryCode}
      hideValidateButton
      isEmptyAddress={isEmptyAddress}
      residentialIndicator={residentialIndicator}
      shouldTruncateValidationIssue={false}
      validation={validation}
      validationIssueMessageClassName={style['validation-issue-message']}
      validationMessage={validationMessage}
    />
  );
};

export { AddressValidationStatusContainer };
